<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame">
<p class="alsoTitle"><span>ALSO BY JUNE COTNER</span></p>
<p class="alsoText">Amazing Graces</p>
<p class="alsoText">Animal Blessings</p>
<p class="alsoText">Baby Blessings</p>
<p class="alsoText">Bedside Prayers</p>
<p class="alsoText">Bless the Beasts</p>
<p class="alsoText">Bless the Day</p>
<p class="alsoText">Christmas Blessings</p>
<p class="alsoText">Comfort Prayers</p>
<p class="alsoText">Dog Blessings</p>
<p class="alsoText">Family Celebrations</p>
<p class="alsoText">Forever in Love</p>
<p class="alsoText">Get Well Wishes</p>
<p class="alsoText">Graces</p>
<p class="alsoText">Heal Your Soul, Heal the World</p>
<p class="alsoText">The Home Design Handbook</p>
<p class="alsoText">House Blessings</p>
<p class="alsoText">Looking for God in All the Right Places</p>
<p class="alsoText">Miracles of Motherhood</p>
<p class="alsoText">Mothers and Daughters</p>
<p class="alsoText">Pocket Prayers</p>
<p class="alsoText">Say a Little Prayer: A Journal</p>
<p class="alsoText">Serenity Prayers</p>
<p class="alsoText">Teen Sunshine Reflections</p>
<p class="alsoText">To Have and To Hold</p>
<p class="alsoText">Wedding Blessings</p>
<p class="alsoText"><span class="Baskerville-Italic">Wishing You Well </span><span class="Baskerville-Italic"></span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// also_by.vue?ebdd7c3e